import { Tasks } from './Tasks'


export class VenueTasks extends Tasks {

  constructor(props, options) {
    super(props, options)
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/VenueTasks.js